export const env = {
  uid: "0", // 用户 uid, 用于日志上下文或登录校验
};

/** 游戏 id，用于共享 GameToolRuntime 初始化 */
export const GAME_ID = 78487;

/** 游戏工具 id，用于数据中台上报，各项目按自身 manifest.json 中的 toolId 填写 */
export const TOOL_ID = "oxxtcnni";

/** 游戏工具类型，用于数据中台上报，见 GameToolInfo.toolType */
export const TOOL_TYPE = 3; // map=3, wiki=1
